import React, { useState, useEffect, useReducer } from "react";
import { Row, Col, Card, message, Divider, Select, Typography, Space, Progress } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";
import { reducerRegister } from "../../../helpers/reducers";
import { maskMoney, parseToInt } from "../../../helpers/masks";
const { Text } = Typography;

const array_votou = [
  { label: "Todos", value: 999 },
  { label: "Votou", value: 1 },
  { label: "Não Votou", value: 2 },
];
export const EleicoesCipaEleitores = ({ to }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const id_eleicoes_localidades = !!searchParams.get("id_eleicoes_localidades")
    ? searchParams.get("id_eleicoes_localidades")
    : 999;
  const status = !!searchParams.get("status") ? searchParams.get("status") : 999;
  const navigate = useNavigate();
  const { id_eleicoes } = useParams();
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);
  const [eleicao, setEleicao] = useState({});
  const [eleicoesLocalidades, setEleicoesLocalidades] = useState([]);

  useEffect(() => {
    if (id_eleicoes) {
      listarEleicoesLocalidades(id_eleicoes);
      carregarEleicao(id_eleicoes);
      listarEleitores(id_eleicoes);
    }
  }, [id_eleicoes]);

  // CARREGAR ELEIÇÃO
  const carregarEleicao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_eleicoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) setEleicao(api.response.data);
    } else {
      message.error(api.response.message);
      navigate(to);
    }
    setLoading(false);
  };

  // LISTAR ELEICOES LOCALIDADES
  const listarEleicoesLocalidades = async (id) => {
    const api = await http("get", `v1/eleicoes_cipa_eleicoes_localidades/listar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      let array = [];
      if (!!response) {
        for (let e of response) {
          array.push({
            value: e.id,
            label: e.localidade,
          });
        }
      }
      setEleicoesLocalidades(array);
    } else {
      message.error(api.response.message);
    }
  };

  // LISTAR
  const listarEleitores = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_lancamento/listar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;

      dispatch({ type: "LOAD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarEleitor = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/eleicoes_cipa_lancamento/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      if (api?.response?.data) dispatch({ type: "UPDATE", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Colaborador",
      dataIndex: "colaborador",
    },
    {
      title: "Filial",
      dataIndex: "filial",
    },
    {
      title: "Localidade",
      width: 100,
      dataIndex: "id_eleicoes_localidades",
      render: (_, e) => (
        <Select
          placeholder="Selecione a localidade"
          style={{ minWidth: 200 }}
          value={e?.id_eleicoes_localidades}
          disabled={loading || e?.status === 1 || [1, 0].includes(eleicao?.status)}
          options={eleicoesLocalidades}
          onChange={(value) => alterarEleitor({ id: e?.id, id_eleicoes_localidades: value })}
        />
      ),
    },
    {
      title: "Situação",
      dataIndex: "status",
      width: 50,
      render: (_, e) => (e?.status === 2 ? <Text type="danger">Não votou</Text> : <Text type="success">Votou</Text>),
      renderText: (e) => (e?.status === 2 ? "Não votou" : "Votou"),
    },
  ];

  const filteredData = React.useMemo(
    () => handleFilter(dados, parseToInt(id_eleicoes_localidades), parseToInt(status)),
    [dados, id_eleicoes_localidades, status]
  );

  const total_realizados = dados?.filter((e) => e?.status === 1);

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Eleições CIPA" onClickBack={() => navigate(to)} />
            <HeaderTitle
              title={["Eleições", "Eleitores"]}
              subtitle={eleicao?.descricao ?? ""}
              icon={<UserOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Progress
                type="line"
                size="small"
                format={(percent) => maskMoney(percent, 2) + "%"}
                percent={dados?.length > 0 ? (total_realizados?.length / dados?.length) * 100 : 0}
              />
              <TableCustom
                extraHeaderComponents={
                  <>
                    <Space direction="vertical" size={0}>
                      <Text style={{ fontSize: 12 }} type="secondary">
                        Localidade:
                      </Text>
                      <Select
                        placeholder="Selecione a localidade"
                        style={{ minWidth: 200 }}
                        value={parseToInt(id_eleicoes_localidades)}
                        disabled={loading}
                        options={[{ value: 999, label: "Todos" }, ...eleicoesLocalidades]}
                        onChange={(val) =>
                          setSearchParams((state) => {
                            state.set("id_eleicoes_localidades", val);
                            return state;
                          })
                        }
                      />
                    </Space>
                    <Space direction="vertical" size={0}>
                      <Text style={{ fontSize: 12 }} type="secondary">
                        Situação:
                      </Text>
                      <Select
                        placeholder="Selecione uma opção"
                        style={{ minWidth: 200 }}
                        value={parseToInt(status)}
                        disabled={loading}
                        options={array_votou}
                        onChange={(val) =>
                          setSearchParams((state) => {
                            state.set("status", val);
                            return state;
                          })
                        }
                      />
                    </Space>
                  </>
                }
                loading={loading}
                columns={columns}
                dataSource={filteredData}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};

const handleFilter = (data, id_eleicoes_localidades, status) => {
  if (data?.length === 0) {
    return [];
  }

  let filteredData = data;
  if (id_eleicoes_localidades !== 999) {
    filteredData = filteredData?.filter((e) => e?.id_eleicoes_localidades === id_eleicoes_localidades);
  }

  if (status !== 999) {
    filteredData = filteredData?.filter((e) => e?.status === status);
  }

  return filteredData;
};
